import  { useRef, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoCamera } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { categories } from "../../helpers/mock-data";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { createLesson } from "../../services/documents/documents.context";
import VideoPlayer from "../../components/utilities/video-player";
import { AppFooter } from "../../components/main-components/footer";


export const AddLesson = () => {

    const { token } = useAuth();

    const navigateTo = useNavigate();

    const fileButton = useRef();

    const [onErr, setOnErr] = useState(false);

    const [inputData, setInputData] = useState({
        document: '',
        title: '',
        field: '',
    });

    const [prevName, setPrevName] = useState(null);

    const [loading, setLoading] = useState(false);
    const [valError, setValError] = useState({
        caption: null,
        message: null
    });

    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = () => {
        const { title, document, field } = inputData;
        return isNull (title) || isNull(document) || isNull(field);
    }


    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Add a Lesson"} />
            {(loading) && <Loader />}
            {onErr && 
                <AppAlert 
                    caption={valError.caption}
                    message={valError.message}
                    close={() => setOnErr(false)}
                    accept={"Ok"}
                    acceptAction={() => {
                        setValError(null);
                        setOnErr(false);
                    }}
                />
            }
            <div className="form-container">
                <div className="input-container">
                    <span className="input-cap">
                        Title
                        <span className="req-asterix">*</span>
                    </span>
                    
                    <input 
                        type="text" 
                        placeholder="Enter lesson title" 
                        className="input"
                        onChange={(e) => setInputData((data) => 
                            ({...data, title: e.target.value})
                        )}
                        value={inputData.title}
                    />
                </div>
                <div className="input-container">
                    <span className="input-cap">
                        Field of study
                        <span className="req-asterix">*</span>
                    </span>
                    <select 
                        type="text" 
                        name="category" 
                        id="category" 
                        className={classNames("input", "category")} 
                        required
                        onChange={(e) => setInputData((data) => (
                            {...data, field: e.target.value}
                        ))}
                    >
                        <option defaultValue={''} selected disabled>
                            ---Choose subject area---
                        </option>
                        {categories.map((category, i) => (
                            <option value={category} key={i} >{category}</option>
                        ))}
                    </select>
                </div>
                <div className="file-btn-container">
                    <input 
                        type="file"
                        className="file-button"
                        ref={fileButton}
                        onChange={(e) => {
                            e.preventDefault();
                            let fileType = e.target.files[0].type.split("/")[0];

                            if (fileType !== "video") {
                                setOnErr(true);
                                setValError((err) => (
                                    {
                                        ...err, 
                                        caption: "Error!",
                                        message: `Invalid file of type ${fileType}! Please upload a file of type video`
                                    }
                                ))
                                return;
                            }
                            const uploadedFile = e.target.files[0];
                           
                            setPrevName(URL.createObjectURL(uploadedFile));
                            setInputData((data) => (
                                {...data, document: e.target.files[0]}
                            ))
                        }} 
                    />
                    <button
                        onClick={() => fileButton.current.click()}
                        className="file-click"
                    >
                        <FontAwesomeIcon icon={faVideoCamera} style={{marginRight: 8}} />
                        Upload file
                    </button>
                </div>

                { prevName &&( 
                <div className={classNames("prev")}>
                    <VideoPlayer
                        src={prevName}
                        style={{width: 300, display: "block"}}
                    />
                </div>)
                }
                
                <button 
                    className="form-button"
                    onClick={ async (e) => {
                        e.preventDefault();
                        if (inputRequired()) {
                            setOnErr(true);
                            setValError((err) => (
                                {
                                    ...err, 
                                    caption: "Error!",
                                        message: "Please provide all the required data"
                                }
                            ))
                            return;
                        }else{
                            setOnErr(false);
                            setValError((err) => ({...err, caption: null, message: null}));
                        }
                        setLoading(true);
                        const d = await createLesson(token, inputData);
                        setLoading(false);
                        setValError({
                            caption: "Success",
                            message: d?.message
                        })
                        setOnErr(true);
                        navigateTo("/addquestions",{state:{tutorial: d?.tutorial} })
                    }}
                >
                    Upload Tutorial
                </button>
            </div>
            <AppFooter />
        </div>
    );
}